import {MAX_VOLUME_DB,MIN_VOLUME_DB} from '../../vendor/src/features/remotion-editor/editor/utils/decibels';

export type VolumeDragOrigin={volume:number;clientY:number;height:number;moved:boolean};

/** A click must not change gain. Keep the pointer-to-line grab offset during a real drag. */
export function volumeAfterPointerMove(origin:VolumeDragOrigin,clientY:number):number|null {
  if(![origin.volume,origin.clientY,origin.height,clientY].every(Number.isFinite)||origin.height<=0)return null;
  const delta=origin.clientY-clientY;
  if(!origin.moved&&Math.abs(delta)<3)return null;
  return Math.max(MIN_VOLUME_DB,Math.min(MAX_VOLUME_DB,
    origin.volume+delta/origin.height*(MAX_VOLUME_DB-MIN_VOLUME_DB)));
}
